import React from 'react';
import Box from 'components/box';

const LayoutContent = props => <Box padding={5} {...props} />;

export default LayoutContent;
